import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexToasts',
  setup(__props) {

const BasicToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/BasicToasts.vue"))
const IconToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/IconToasts.vue"))
const PositionToasts = defineAsyncComponent(() => import("@/components/theme/advance/toasts/PositionToasts.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(BasicToasts)),
      _createVNode(_unref(IconToasts)),
      _createVNode(_unref(PositionToasts))
    ])
  ]))
}
}

})